import React from 'react'

import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  fill: {
    fill: theme.palette.primary.main
  },
  paper: {
    fill: '#fff',
    stroke: theme.palette.primary.main,
    strokeWidth: 5
  }
}))

export default function TextThumbnail({ ...props }) {
  const classes = useStyles(props)

  return (
    <svg viewBox="0 0 150 200">
      <rect x={0} y={60} width={75} height={20} className={classes.fill} />
      <rect x={0} y={90} width={150} height={20} className={classes.fill} />
      <rect x={0} y={120} width={150} height={20} className={classes.fill} />
    </svg>
  )
}
